import React, { useEffect, useState } from 'react';
import { Radio, Spin, Tag, Typography, Empty } from 'antd';
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const LENTES = [
  { value: 'cotizar', label: 'Para cotizar' },
  { value: 'equipos', label: 'Equipos' },
  { value: 'tipos', label: 'Tipos de falla' },
  { value: 'regresiones', label: 'Volvieron a aparecer' },
];

// Solo dos lentes son un ranking; los otros dos son filtros directos sobre la lista.
const EJE_POR_LENTE = { equipos: 'equipo', tipos: 'tipo_falla' };

function FranjaPatrones({ lente, onLenteChange, onFiltroPatron, clienteId }) {
  const [patrones, setPatrones] = useState([]);
  const [loading, setLoading] = useState(false);

  const eje = EJE_POR_LENTE[lente];

  useEffect(() => {
    if (!eje) {
      setPatrones([]);
      return;
    }
    let cancelado = false;
    setLoading(true);
    axios
      .get(`${API_PATH}/actividades-hallazgo/patrones`, {
        params: { eje, cliente_id: clienteId || undefined },
        headers: { Authorization: getAccessTokenApi() },
      })
      .then((res) => {
        if (!cancelado) setPatrones(res.data || []);
      })
      .catch(() => {
        if (!cancelado) setPatrones([]);
      })
      .finally(() => {
        if (!cancelado) setLoading(false);
      });
    return () => {
      cancelado = true;
    };
  }, [eje, clienteId]);

  const aplicar = (p) => {
    if (lente === 'equipos') onFiltroPatron({ ascensor_id: Number(p.clave) });
    if (lente === 'tipos') onFiltroPatron({ item_titulo: p.etiqueta });
  };

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <Radio.Group
        value={lente}
        onChange={(e) => onLenteChange(e.target.value)}
        optionType="button"
        buttonStyle="solid"
        options={LENTES}
      />

      {eje ? (
        <div className="mt-4">
          {loading ? (
            <Spin size="small" />
          ) : patrones.length === 0 ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <Typography.Text type="secondary">Sin problemas abiertos</Typography.Text>
              }
            />
          ) : (
            <div className="flex flex-col gap-1">
              {patrones.map((p) => (
                <div
                  key={p.clave}
                  role="button"
                  tabIndex={0}
                  onClick={() => aplicar(p)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') aplicar(p);
                  }}
                  className="flex cursor-pointer items-center justify-between rounded-lg px-3 py-2 hover:bg-slate-50"
                >
                  <span className="text-sm text-slate-700">{p.etiqueta}</span>
                  <span className="flex items-center gap-2">
                    <Typography.Text type="secondary" className="text-xs">
                      {p.grupos} {p.grupos === 1 ? 'problema' : 'problemas'}
                      {lente === 'tipos' && p.equipos > 1 ? ` en ${p.equipos} equipos` : ''}
                    </Typography.Text>
                    {p.criticos > 0 ? <Tag color="red">{p.criticos} graves</Tag> : null}
                    {p.recurrentes > 0 ? (
                      <Tag color="volcano">{p.recurrentes} recurrentes</Tag>
                    ) : null}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
}

export default FranjaPatrones;
